import {FeatureLibrary, FEATURE_LIBRARY_BASE_URL} from 'molbio/feature-libraries/FeatureLibraryConstants';
import * as net from 'util/Net';

export function fetch(): Promise<Array<FeatureLibrary>> {
  return net.getJSONPromise(FEATURE_LIBRARY_BASE_URL);
}
